"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCsAssetRequestToJSON = exports.CreateCsAssetRequestFromJSONTyped = exports.CreateCsAssetRequestFromJSON = void 0;
var LinkedAssetRequest_1 = require("./LinkedAssetRequest");
var SurveyAssetRequest_1 = require("./SurveyAssetRequest");
function CreateCsAssetRequestFromJSON(json) {
    return CreateCsAssetRequestFromJSONTyped(json, false);
}
exports.CreateCsAssetRequestFromJSON = CreateCsAssetRequestFromJSON;
function CreateCsAssetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, LinkedAssetRequest_1.LinkedAssetRequestFromJSONTyped)(json, true)), (0, SurveyAssetRequest_1.SurveyAssetRequestFromJSONTyped)(json, true));
}
exports.CreateCsAssetRequestFromJSONTyped = CreateCsAssetRequestFromJSONTyped;
function CreateCsAssetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    if ((0, LinkedAssetRequest_1.instanceOfLinkedAssetRequest)(value)) {
        return (0, LinkedAssetRequest_1.LinkedAssetRequestToJSON)(value);
    }
    if ((0, SurveyAssetRequest_1.instanceOfSurveyAssetRequest)(value)) {
        return (0, SurveyAssetRequest_1.SurveyAssetRequestToJSON)(value);
    }
    return {};
}
exports.CreateCsAssetRequestToJSON = CreateCsAssetRequestToJSON;
